<script>
  import Editor from "./Editor.svelte";
</script>

<main>
  <Editor title="Clio" share={true} query="code" />
</main>

<style>
  main {
    height: 100vh;
    overflow: hidden;
  }
</style>
